import {Form, Input} from 'antd';
import {FormInstance} from 'antd/es/form/Form';
import React, {useEffect} from 'react';

import {CustomSelect} from 'components/form/inputs/custom-select';

import {IRisksRequestDto, ISendServiceArgs} from '../../api/types';
import {RisksRequestsService} from '../../services';

interface IProps {
    form: FormInstance;
    request?: IRisksRequestDto;
    fetchData: () => Promise<void>;
}

export const SendResponseForm = ({form, request, fetchData}: IProps) => {
    useEffect(() => {
        if (request) {
            form.setFieldsValue({externalServiceId: request.externalServiceId, requestNumber: request.requestId});
        }
    }, [form, request]);

    const handleSendServiceFinish = async (values: ISendServiceArgs) => {
        try {
            await RisksRequestsService.sendService(values);
            await fetchData();
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={handleSendServiceFinish}
        >
            <Form.Item
                name="externalServiceId"
                label="Наименование сервиса"
                required
            >
                <CustomSelect
                    settings={{
                        isDisabled: true,
                        url: 'ais/valueLists/AIS_SERVICES',
                        valuePath: 'id',
                        labelPath: 'description',
                    }}
                />
            </Form.Item>
            <Form.Item
                name="requestNumber"
                label="Номер запроса"
                required
            >
                <Input disabled />
            </Form.Item>
        </Form>
    );
};
